export const batteryStatuses = {
  charging: 'charging',
  discharging: 'discharging',
  idle: 'idle',
  error: 'error',
}
